import { useAsync } from '@nxsys/hooks/useAsync';
import { getUrgentActionsApi } from '@nxsys/services/api/urgentActions';
import { UrgentActionsResponse } from '@nxsys/types/api/urgentActions';
import { showMessage } from '@nxsys/utils/message';
import { useEffect } from 'react';
import { getErrorMessage } from '@nxsys/utils/getErrorMessage';

export const useUrgentActions = () => {
  const { value, loading, error, run } = useAsync<UrgentActionsResponse, void>(
    getUrgentActionsApi,
  );

  useEffect(() => {
    if (error) {
      showMessage({ type: 'error', content: getErrorMessage(error) });
    }
  }, [error]);

  return { value, loading, error, run };
};
